<h5>{{pedimento?.title}}</h5>
<mat-grid-list cols="2" rowHeight="100px" height="400px">
    <mat-grid-tile>
        <mat-form-field appearance="fill" [formGroup]="FormPedimentos">
            <mat-label>Ejercicio Aduana Patente (1 digitos)Cantidad(6 digitos) </mat-label>
            <input matInput placeholder="ej. 99 99 9999 9999999" formControlName="pedimento" minlength="18" maxlength="18" required>
            <mat-hint>Formato: 99 99 9999 9999999</mat-hint>  
            <mat-error *ngIf="(this.f['pedimento'].errors?.['required'])">
                El campo es requerido.
            </mat-error>          
            <mat-error *ngIf="(this.f['pedimento'].errors?.['pattern'])">
                El valor ingresado no es válido.
            </mat-error>
        </mat-form-field>
        
    </mat-grid-tile>
</mat-grid-list>


